/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_Group_Title_PlaceholderInputs */

const cs_chat_new_group_title_placeholder = /** @type {(inputs: Chat_New_Group_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`např. Novinky Praha`)
};

const en_chat_new_group_title_placeholder = /** @type {(inputs: Chat_New_Group_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Prague office news`)
};

/**
* | output |
* | --- |
* | "e.g. Prague office news" |
*
* @param {Chat_New_Group_Title_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_group_title_placeholder = /** @type {((inputs?: Chat_New_Group_Title_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_Group_Title_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_group_title_placeholder(inputs)
	return cs_chat_new_group_title_placeholder(inputs)
});